import React from "react"
import Link from "components/Link"
import { CONTACT_URL } from "constants/urls"
import NavPanel from "./NavPanel"

function NavItem({ path, label, items, onContactSalesClick, ...rest }) {
  const isContactSales = path === CONTACT_URL

  const handleClick = (e) => {
    if (isContactSales && onContactSalesClick) {
      e.preventDefault()
      onContactSalesClick()
    }
  }

  return (
    <li className="group relative" key={label}>
      <Link
        className="inline-block whitespace-nowrap py-3 text-current transition-colors group-hover:text-lush"
        href={path || items?.[0]?.path}
        onClick={handleClick}
      >
        {label}
      </Link>
      <NavPanel items={items} {...rest} />
    </li>
  )
}

export default NavItem
